import React from 'react';

const EducationAbroadBottomline = () => {
  const benefits = [
    {
      title: "Strategic Asset Allocation",
      description: "A carefully balanced approach combining growth assets for long-term inflation protection with safer investments as the enrollment date approaches ensures optimal funding readiness."
    },
    {
      title: "Currency Management",
      description: "Proactive planning for currency fluctuations through forex-linked investments and strategic timing of fund transfers can save significant amounts over the education period."
    },
    {
      title: "Tax-Optimized Funding",
      description: "Leveraging tax-advantaged education planning vehicles and structuring gifts from family members in tax-efficient ways maximizes the effective value of your education fund."
    },
    {
      title: "Continuous Adaptation",
      description: "Regular reassessment of funding strategies as university costs change and as financial markets evolve ensures your education abroad plan remains robust through changing conditions."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic Education Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EducationAbroadBottomline;